<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        @if (materialType === materialTicketType.SandGravel) {
            <div class="row">
                <div class="col-sm-8 col-12 form-group">
                    <label for="job-sandgravel">Job</label>
                    <wj-auto-complete
                        [(ngModel)]="target.job"
                        name="job-sandgravel"
                        id="job-sandgravel"
                        [isRequired]="false"
                        [maxItems]="100"
                        [itemsSource]="jobMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-auto-complete>
                </div>
                <div class="col-sm-4 col-12 form-group">
                    <label for="date-sandgravel">Ticket Date</label>
                    <wj-input-date
                        [(ngModel)]="target.date"
                        name="date-sandgravel"
                        id="date-sandgravel"
                        [isRequired]="false"
                    ></wj-input-date>
                </div>
            </div>
        }
        @if (materialType === materialTicketType.HaulOff) {
            <div class="row">
                <div class="col-sm-3 col-12 form-group">
                    <label for="hasDumpFee">Haul Off Type</label>
                    <wj-auto-complete
                        [(ngModel)]="hasDumpFee"
                        name="hasDumpFee"
                        id="hasDumpFee"
                        [isRequired]="true"
                        [maxItems]="100"
                        [itemsSource]="haulOffTypeOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-auto-complete>
                </div>
                <div class="col-sm-6 col-12 form-group">
                    <label for="job-hauloff">Job</label>
                    <wj-auto-complete
                        [(ngModel)]="target.job"
                        name="job-hauloff"
                        id="job-hauloff"
                        [isRequired]="false"
                        [maxItems]="100"
                        [itemsSource]="jobMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-auto-complete>
                </div>
                <div class="col-sm-3 col-12 form-group">
                    <label for="date-hauloff">Ticket Date</label>
                    <wj-input-date [(ngModel)]="target.date" name="date-hauloff" id="date-hauloff" [isRequired]="false"></wj-input-date>
                </div>
            </div>
        }
        @if (materialType === materialTicketType.Concrete) {
            <div class="row">
                <div class="col-md-4 col-12 form-group">
                    <label for="job-concrete">Job</label>
                    <wj-auto-complete
                        [(ngModel)]="target.job"
                        name="job-concrete"
                        id="job-concrete"
                        [isRequired]="false"
                        [maxItems]="100"
                        [itemsSource]="jobMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-auto-complete>
                </div>
                <div class="col-md-4 col-12 form-group">
                    <label for="date-concrete">Ticket Date</label>
                    <wj-input-date [(ngModel)]="target.date" name="date-concrete" id="date-concrete" [isRequired]="false"></wj-input-date>
                </div>
                <div class="col-md-2 col-12 form-group">
                    <label for="concreteType">Type</label>
                    <wj-auto-complete
                        [(ngModel)]="target.concreteType"
                        name="concreteType"
                        id="concreteType"
                        [isRequired]="false"
                        [maxItems]="100"
                        [itemsSource]="concreteTypeMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-auto-complete>
                </div>
                <div class="col-md-2 col-12 form-group">
                    <label for="quantity-concrete">Qty (Yards)</label>
                    <input
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.quantity"
                        name="quantity-concrete"
                        id="quantity-concrete"
                    />
                </div>
            </div>
        }
        @if (materialType === materialTicketType.SandGravel || (materialType === materialTicketType.HaulOff && hasDumpFee)) {
            <div class="row">
                <div class="col-12 form-group" [ngClass]="materialType === materialTicketType.SandGravel ? 'col-sm-4' : 'col-sm-6'">
                    <label for="vendor">Vendor</label>
                    <wj-combo-box
                        [(ngModel)]="target.vendor"
                        name="vendor"
                        id="vendor"
                        (ngModelChange)="vendorChanged()"
                        [isRequired]="false"
                        [itemsSource]="vendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
                <div class="col-12 form-group" [ngClass]="materialType === materialTicketType.SandGravel ? 'col-sm-4' : 'col-sm-6'">
                    <label for="lot">{{ materialType === materialTicketType.SandGravel ? 'Pit' : 'Location' }}</label>
                    <wj-combo-box
                        [(ngModel)]="target.lot"
                        name="lot"
                        id="lot"
                        [isRequired]="false"
                        (ngModelChange)="lotChanged()"
                        [itemsSource]="lotOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
                @if (materialType === materialTicketType.SandGravel) {
                    <div class="col-sm-4 col-12 form-group">
                        <label for="material">Material</label>
                        <wj-combo-box
                            #materialComboBox
                            [(ngModel)]="target.material"
                            name="material"
                            id="material"
                            (ngModelChange)="materialChanged()"
                            [isRequired]="false"
                            [itemsSource]="materialOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                }
            </div>
        }
        @if ((materialType === materialTicketType.SandGravel || materialType === materialTicketType.HaulOff) && !isLessor()) {
            <div class="row">
                <div class="col-sm-4 col-12 form-group">
                    <label for="truck">Truck</label>
                    <wj-combo-box
                        [(ngModel)]="target.truck"
                        name="target.truck"
                        id="truck"
                        [isRequired]="false"
                        [itemsSource]="truckOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
                <div class="col-sm-4 col-12 form-group">
                    <label for="trailer1">Trailer 1</label>
                    <wj-combo-box
                        [(ngModel)]="target.trailer1"
                        name="target.trailer1"
                        id="trailer1"
                        [isRequired]="false"
                        [itemsSource]="trailerOptions1"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
                <div class="col-sm-4 col-12 form-group">
                    <label for="trailer2">Trailer 2</label>
                    <wj-combo-box
                        [(ngModel)]="target.trailer2"
                        name="target.trailer2"
                        id="trailer2"
                        [isRequired]="false"
                        [itemsSource]="trailerOptions2"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        }
        @if (materialType === materialTicketType.SandGravel || (materialType === materialTicketType.HaulOff && hasDumpFee)) {
            <div class="row">
                <div class="col-sm-4 col-12 form-group">
                    <label for="quantity-sandgravel">Quantity</label>
                    <input
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.quantity"
                        name="quantity-sandgravel"
                        id="quantity-sandgravel"
                    />
                </div>
                <div class="col-sm-4 col-12 form-group">
                    <label for="units">Units</label>
                    <wj-combo-box
                        [(ngModel)]="target.units"
                        name="units"
                        id="units"
                        [isRequired]="false"
                        [itemsSource]="unitOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
                <div class="col-sm-4 col-12 form-group">
                    <label for="ticket-sandgravel">Ticket #</label>
                    <input type="text" class="form-control" [(ngModel)]="target.ticket" name="ticket-sandgravel" id="ticket-sandgravel" />
                </div>
            </div>
        }
        @if (materialType === materialTicketType.Concrete) {
            <div class="row">
                <div class="col-sm-4 col-12 form-group">
                    <label for="vendor-concrete">Concrete Vendor</label>
                    <wj-combo-box
                        [(ngModel)]="target.vendor"
                        name="vendor-concrete"
                        id="vendor-concrete"
                        (ngModelChange)="vendorChanged()"
                        [isRequired]="false"
                        [itemsSource]="vendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
                <div class="col-sm-4 col-12 form-group">
                    <label for="pumpTruckVendor">Pump Truck Vendor</label>
                    <wj-combo-box
                        [(ngModel)]="target.pumpTruckVendor"
                        name="pumpTruckVendor"
                        id="pumpTruckVendor"
                        [isRequired]="false"
                        [itemsSource]="pumpTruckVendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
                <div class="col-sm-4 col-12 form-group">
                    <label for="testingVendor">Testing Vendor</label>
                    <wj-combo-box
                        [(ngModel)]="target.testingVendor"
                        name="testingVendor"
                        id="testingVendor"
                        [isRequired]="false"
                        [itemsSource]="concreteTesterVendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        }
        @if (materialType === materialTicketType.Concrete) {
            <div class="row">
                <div class="col-sm-4 col-12 form-group">
                    <label for="ticket-concrete">Concrete Ticket #</label>
                    <input type="text" class="form-control" [(ngModel)]="target.ticket" name="ticket-concrete" id="ticket-concrete" />
                </div>
                <div class="col-sm-4 col-12 form-group">
                    <label for="pumpTruckTicket">Pump Truck Ticket #</label>
                    <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="target.pumpTruckTicket"
                        name="pumpTruckTicket"
                        id="pumpTruckTicket"
                    />
                </div>
                <div class="col-sm-4 col-12 form-group">
                    <label for="testingTicket">Testing Ticket #</label>
                    <input type="text" class="form-control" [(ngModel)]="target.testingTicket" name="testingTicket" id="testingTicket" />
                </div>
            </div>
        }
        @if (materialType === materialTicketType.Concrete) {
            <div class="row">
                <div class="col-sm-4 col-12 form-group">
                    <button type="button" class="btn btn-success" style="width: 100%" (click)="fileInput.click()">Add Concrete Ticket Image/File</button>
                </div>
                <div class="col-sm-4 col-12 form-group">
                    <button type="button" class="btn btn-success" style="width: 100%" (click)="fileInput.click()">
                        Add Pump Truck Ticket Image/File
                    </button>
                </div>
                <div class="col-sm-4 col-12 form-group">
                    <button type="button" class="btn btn-success" style="width: 100%" (click)="fileInput.click()">Add Tesing Ticket Image/File</button>
                </div>
            </div>
        }

        <div class="row">
            <div class="col-md-12 form-group">
                <label for="notes">{{ hasDumpFee || materialType !== materialTicketType.HaulOff ? 'Notes' : 'Location' }}</label>
                <input type="text" class="form-control" [(ngModel)]="target.notes" name="notes" id="notes" />
            </div>
        </div>
        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label for="images-display">Images/Files</label>
                @for (url of target.imageUrls; track url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        @if (isPdf(url)) {
                            <img class="attachment-pdf-thumb" style="cursor: pointer" [src]="getExistingImageSrc(url)" (click)="openImage(url)" alt="" />
                        } @else {
                            <img style="max-width: 250px; cursor: pointer" [src]="getExistingImageSrc(url)" (click)="openImage(url)" alt="" />
                        }
                    </div>
                }
            </div>
        }
        @if (images && images.length > 0) {
            <div class="row">
                <label for="images-upload">Images To Upload</label>
                @for (image of images; track image) {
                    <div class="col-sm-6 col-6" style="max-width: 324px; margin-bottom: 10px">
                        <div class="close-x" (click)="removeImage(image)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        @if (image.type === 'application/pdf') {
                            <img class="attachment-pdf-thumb" [src]="getPendingImageSrc(image)" alt="" />
                        } @else {
                            <img style="max-width: 300px" [src]="getPendingImageSrc(image)" alt="" />
                        }
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-success"
            style="margin-right: auto"
            (click)="fileInput.click()"
            [hidden]="(!hasDumpFee && materialType === materialTicketType.HaulOff) || materialType === materialTicketType.Concrete"
        >
            Ticket Image/File
        </button>
        <input style="display: none" type="file" (change)="onFileChanged($event)" accept="image/*,application/pdf" #fileInput multiple />
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
